import React, { FC } from 'react';
import { CardImage, Link } from '@blueprint/ui';
import {
    StyledCard,
    PropertyDetails,
    StyledPropertyTitle,
    StyledPropertyAddress,
    AgentImage,
    AgentImageWrapper,
    PropertyDetailsContainer,
    PropertyImage,
    StyledPropertyPrice
} from './FeaturedProperties.styles';
import { FeaturedPropertyData } from './FeaturedProperties.types';

export type Props = {
    property: FeaturedPropertyData;
    onClick?: () => void;
};

const FeaturedPropertyCard: FC<Props> = (props) => {
    const { property, onClick } = props;
    const queryString = `?${property.featuredType}=1&utm_content=featured_listing`;
    const detailsLink = props.property.listingUris?.detail
        ? `${props.property.listingUris?.detail}${queryString}`
        : '#';

    return (
        <Link
            plain
            href={detailsLink}
            key={property.listingId}
            onClick={onClick}
            data-testid="featured-property-card"
        >
            <StyledCard
                hasShadow={false}
                hasBorder={false}
                hasBackground
                contentAlignment="center"
            >
                <PropertyImage>
                    <CardImage
                        src={property.image.src}
                        responsiveImgList={property.image.responsiveImgList}
                    />
                </PropertyImage>
                <PropertyDetailsContainer>
                    <PropertyDetails>
                        <StyledPropertyPrice color="text-title" size="6" isBold>
                            {property.price}
                        </StyledPropertyPrice>
                        <StyledPropertyTitle color="text-title" size="8" isBold>
                            {property.title}
                        </StyledPropertyTitle>
                        <StyledPropertyAddress
                            color="text-body"
                            size="secondary"
                        >
                            {property.address}
                        </StyledPropertyAddress>
                    </PropertyDetails>
                    <AgentImageWrapper>
                        <AgentImage
                            src={property.branch.logoUrl}
                            alt={property.branch.name}
                        />
                    </AgentImageWrapper>
                </PropertyDetailsContainer>
            </StyledCard>
        </Link>
    );
};

export default FeaturedPropertyCard;
